module.exports = __webpack_public_path__ + "static/media/HCMM360.5138a267.jpg";